import { Brain, Gavel, Scale, Shield } from 'lucide-react';
import { GAZZALI_DISPLAY, virtueScoreToColor } from '../../utils/terminologyMap';

interface Props {
  gazzali_scores?: { hikmet?: number; secaat?: number; iffet?: number; adalet?: number }
  size?: number
}

const ICONS: Record<string, any> = { hikmet: Brain, secaat: Shield, iffet: Scale, adalet: Gavel }

export default function GazzaliVirtueIcons({ gazzali_scores, size = 14 }: Props) {
  if (!gazzali_scores) return null
  const entries = Object.entries(gazzali_scores).filter(([k]) => k in GAZZALI_DISPLAY)
  if (entries.length === 0) return null

  return (
    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
      {entries.map(([key, score]) => {
        const Icon = ICONS[key]
        const color = virtueScoreToColor(score as number)
        const label = GAZZALI_DISPLAY[key]?.label || key
        return (
          <div key={key} title={`${label}: ${((score as number) * 10).toFixed(1)}/10`}
            style={{ cursor: 'help' }}>
            <Icon size={size} color={color} />
          </div>
        )
      })}
    </div>
  )
}
